(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-arena/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/racing-arena/assets/javascripts/prescript.js');

'use strict';

svs = svs || {};
svs.racing_arena = svs.racing_arena || {};


 })(window);